import { render, staticRenderFns } from "./roleModuleSelection.vue?vue&type=template&id=a03bb84a&scoped=true&"
import script from "./roleModuleSelection.vue?vue&type=script&lang=js&"
export * from "./roleModuleSelection.vue?vue&type=script&lang=js&"
import style0 from "./roleModuleSelection.vue?vue&type=style&index=0&id=a03bb84a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03bb84a",
  null
  
)

export default component.exports